// extracted by mini-css-extract-plugin
export default {"photoGrid":"slider_photoGrid__1xrN4","photoItem":"slider_photoItem__t-684","photo":"slider_photo__S0eWH"};